import React from "react";
import { Link } from "react-router-dom";
import "../css/homeCards.css";

function HomeCards() {

    const cards = [
        {
            image: "/images/about.jpg",
            title: "About Us",
            link: "/about"
        },
        {
            image: "/images/close-up-brown-liquid.jpg",
            title: "Our Products",
            link: "/products"
        },
        {
            image: "/images/contact.jpg",
            title: "Contact Us",
            link: "/contact"
        }
    ];

    return (
        <section className="home-cards">

            {cards.map((card, index) => (

                <Link
                    to={card.link}
                    className="home-card"
                    key={index}
                >

                    <img
                        src={card.image}
                        alt={card.title}
                    />

                    <div className="home-card-overlay"></div>

                    <h2>{card.title}</h2>

                </Link>

            ))}

        </section>
    );
}

export default HomeCards;